const style = {
    container: {
        width: "100%",
        height: "100%",
        background: "#181a20",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
    },
    body: {
        width: "100%",
        height: "calc(100vh - 90px)",
    },
    bodyGrid: {
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateColumns: "450px 1fr",
    },
};

export default style;